import { danger, info, neutral, primary, success, warning } from "./colors";
import { ArrowDropDown } from "@mui/icons-material";
export const components = {
  MuiFormControl: {
    defaultProps: {
      fullWidth: true,
    },
    styleOverrides: {
      root: {
        marginTop: "16px",
        "& .MuiFormHelperText-root": {
          transform: "translate(-14px)",
          fontSize: "14px",
          marginTop: "6px",
        },
      },
    },
  },
  MuiInput: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: {
        fontSize: "16px",
        backgroundColor: "#fff",
        border: `1px solid ${neutral[300]}`,
        borderRadius: "8px",
        height: "48px",
        padding: "8px 12px",
        width: "100%",
        transition: ".25s",
        "& ::placeholder": {
          color: neutral[500],
        },
        "&.Mui-focused": {
          border: `1px solid ${primary[300]}`,
          boxShadow: `0px 0px 0px 3px ${primary[100]}`,
        },
        "&:not([datatype='select-input'])": {},
        "&.Mui-error": {
          border: `1px solid ${danger[300]}`,
          "& svg": {
            color: danger[500],
          },
          "&.Mui-focused": {
            border: `1px solid ${danger[300]}`,
            boxShadow: `0px 0px 0px 3px ${danger[100]}`,
          },
        },
        "&.MuiInputBase-multiline": {
          height: "auto",
        },
        "& svg.MuiSelect-icon": {
          fontSize: "20px",
          right: "12px",
          "& polyline": {
            strokeWidth: "20px",
          },
        },
      },
    },
  },
  MuiInputLabel: {
    defaultProps: {
      shrink: true,
    },
    styleOverrides: {
      root: {
        marginBottom: "4px",
        color: "inherit",
        "& .MuiFormLabel-asterisk": {
          color: danger[400],
        },
      },
      shrink: {
        fontSize: "14px",
        transform: "scale(1) translate(0px, -8px)",
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: "14px",
        marginBottom: "4px",
        color: "inherit",
        "& .MuiFormLabel-asterisk": {
          color: danger[400],
        },
      },
    },
  },
  MuiSelect: {
    defaultProps: {
      variant: "standard",
      disableUnderline: true,
      datatype: "select-input",
      MenuProps: {
        PaperProps: {
          className: "select-dropdown",
        },
      },
      IconComponent: ArrowDropDown,
    },
    styleOverrides: {
      standard: {
        ":focus": {
          backgroundColor: "#fff",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // ---- style overrides for input date ----
          "&.date-picker": {
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
              backgroundColor: "#fff",
              borderRadius: "8px",
              height: "48px",
              padding: "8px 12px",
              width: "100%",
              transition: ".25s",
              fontSize: "16px",
              "&::placeholder": {
                color: neutral[500],
              },
              "& input": {
                paddingLeft: 0,
              },
              "&.Mui-focused": {
                border: `1px solid ${primary[300]}`,
                boxShadow: `0px 0px 0px 3px ${primary[100]}`,
                "& fieldset,&:hover fieldset": {
                  border: "none",
                },
              },
              "&:hover fieldset": {
                border: `1px solid ${neutral[300]}`,
              },
              "& button svg": {
                fontSize: "20px",
                marginRight: "6px",
                "& polyline": {
                  strokeWidth: "20px",
                },
              },
            },
          },
        },
      },
    },
  },
};
